const clearUrl = (url: string) => {
    const newurl = new URL(url);
    return newurl.pathname.substring(1);
};

export const getSeoUrl = async (url: string) => {
    const urlClear = clearUrl(url);
    const urlArray = urlClear.split('/');
    const myHeaders = new Headers();
    myHeaders.append('x-api-key', process.env.REACT_APP_MICRO_GET_URL_SEARCH_XAPIKEY);
    const requestOptions = {
        method: 'GET',
        headers: myHeaders,
    };
    const urlArea = urlArray[0] ? `area=${urlArray[0]}` : '';
    const urlTipos = urlArray[1] ? `&tipos=${urlArray[1]}` : '';
    const urlRequest = `${process.env.REACT_APP_MICRO_GET_URL_SEARCH}?${urlArea}${urlTipos}`;
    const res = await fetch(urlRequest, requestOptions);
    return res.json();
};

export const postSeoUrl = async (data: any, token: any) => {
    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);
    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: JSON.stringify(data),
    };
    const urlRequest = process.env.REACT_APP_MICRO_POST_SEPOMEX_DESCRIPTION;
    const res = await fetch(urlRequest, requestOptions);
    return res.json();
};
